module.exports = __webpack_public_path__ + "media/images/socials/instagram-30af59de529a5a89bfd8439fbb5d2b46.png";